<template>
  <div>
    <main class="jackpot-main">
      <div class="row">
        <div class="col-2 cloud-l">
          <span class="waves wave1"></span>
        </div>
        <div class="col-8 treasure_island_simple">
          <img class="jackpot ti_jackpot" src="static/images/icon-jackpot.png" />
        </div>
        <div class="col-2 cloud-r">
          <span class="waves wave2"></span>
        </div>
        <div class="col-12 jackpot_title">
          {{ getTranslations.home_jackpot_title }}
      </div>
      </div>
      <div class="row jackpot_timer_row">
        <div class="col-1 jackpot_timer_image"></div>
        <div class="col-9 jackpot_timer_message"
             style="cursor: pointer"
             @click.prevent="showInfo = true;">
          {{ getTranslations.home_jackpot_next_winners }}
      </div>
        <div class="col-2"></div>
      </div>
      <div class="jackpot_status_section">
        <!-- JACKPOT SLIDER -->
        <div class="row">
          <div class="col-md-12">
            <div class="tab-container__item active"
                 id="daily">
              <div class="prizes__carousel">
                <div class="jackpot prizes-carousel generic-carousel">
                  <div class="item"
                       :key="index"
                       v-if="getPrizes.length"
                       v-for="(item, index) in getPrizes">
                    <div class="jackpot_ribbon prize_stock"
                         :data-ribbon-value="getRibbonValue(item.itemsLeft)">
                    </div>
                    <img class="jackpot_carousel_prize"
                         :src="item.prizeDTO.imageUrl || 'static/images/prize_monthly_01.png'"
                         alt="preview">
                  </div>
                </div>
                <div class="carousel__nav"></div>
              </div>
            </div>
          </div>
        </div>
        <!-- JACKPOT SLIDER END -->
        <div class="row jackpot_status_header">
          <div class="col-12">{{ getTranslations.home_jackpot_status }}</div>
        </div>
        <div class="row jackpot_status_row"
             :key="index"
             v-for="(rankInfo, index) in jackpotRankData">
          <div class="col-4 jackpot_ponts_title">
            {{ getTranslations[getTranslationBasedOnCategory(rankInfo.rankKeyType)] }}
          </div>
          <div class="col-1 jackpot_ponts_value">
            {{ rankInfo.points }}
          </div>
          <div class="col-2"></div>
          <div class="col-3 jackpot_ponts_top">
            {{ percentageDisplay(rankInfo.percentage, rankInfo.value)[0] }}
          </div>
          <div class="col-2 jackpot_ponts_top_percent">
            {{ percentageDisplay(rankInfo.percentage, rankInfo.value)[1] }}
          </div>
        </div><div class="row jackpot_status_share" v-if="hasFbShare()">
          <div class="col-12" v-show="eligibleForReward">
            {{ getTranslations.home_jackpot_share_fb }} {{ getFbPoints }} {{ getTranslations.home_jackpot_fb_points }}
          </div>
          <div class="col-12">
            <a style="cursor:pointer"
               @click.prevent="shareJackpot()">
              <i class="icon-facebook"></i>
              <span>{{ getTranslations.home_store_share }}</span>
            </a>
          </div>
        </div>
      </div>
    </main>
    <jackpot-prizes v-if="showInfo" @close="showInfo = false"></jackpot-prizes>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import JackpotPrizes from '@/components/home/modals/JackpotPrizes';
import RoundUpMixin from '@/common/mixins/roundUp';
import FacebookMixin from '@/common/mixins/facebookIntegration';
import NumbersFormattingMixin from '@/common/mixins/numbersFormatting';

export default {
  name: 'jackpot',
  mixins: [RoundUpMixin, FacebookMixin, NumbersFormattingMixin],
  components: { JackpotPrizes },
  data() {
    return {
      showInfo: false,
      action: 'SHARE_JACKPOT',
      fb_error: false,
      redirectUrl: '',
      eligibleForReward: false,
    };
  },
  created() {
    if (this.hasFbShare()) {
      this.isEligibleForSharePoints({ action: this.action }).then((response) => {
        this.eligibleForReward = response.data;
      });
    }
    this.fetchData();
    this.redirectUrl = `${window.location.href}/${this.getLocale || localStorage.getItem('locale')}/`;
    this.forceFbToScrapNewMetadata(this.redirectUrl, () => {
      // eslint-disable-next-line
      console.log('successful scrapping!');
    });
  },
  methods: {
    ...mapActions('profile', [
      'storeJackpotPrizes',
      'storeJackpotRankData',
      'giveContent',
      'isEligibleForSharePoints',
    ]),
    percentageDisplay(percentage, rank) {
      if (rank <= 50 || !percentage) return [this.getTranslations.home_jackpot_your_rank, rank];
      return [this.getTranslations.home_jackpot_top, `${percentage}%`];
    },
    getTranslationBasedOnCategory(category) {
      switch (category) {
      case 'DAILY': return 'home_jackpot_daily_points';
      case 'WEEKLY': return 'home_jackpot_weekly_points';
      case 'MONTHLY': return 'home_jackpot_monthly_points';
      case 'GRAND': return 'home_jackpot_total_points';
      default: return `home_jackpot_custom_${category.charAt(category.length - 1)}`;
      }
    },
    getRibbonValue(prizeQuantity) {
      return `x${prizeQuantity}`;
    },
    hasFbShare() {
      return this.userDetails.facebookId && this.facebookFunctionality;
    },
    assignPoints() {
      this.giveContent({ action: this.action, points: this.getFbPoints });
    },
    showError() {
      this.fb_error = true;
    },
    shareJackpot() {
      this.fb_error = false;
      this.share(
        this.userDetails.facebookId,
        this.userDetails.id,
        this.assignPoints,
        this.showError,
      );
    },
    initCarousel() {
      // const self = this;
      this.$nextTick(() => {
        /* eslint-disable */
        $('.prizes-carousel').owlCarousel({
          loop: false,
          responsiveClass: true,
          dots: this.jackpotPrizes.length > 1,
          autoplay:false,
          autoplayTimeout:5000,
          autoplayHoverPause:true,
          navContainer: '.carousel__nav',
          dotsContainer: '.prizes__carousel__dots',
          navText: this.jackpotPrizes.length > 1 ? ['<i class=\'icon-arrow-left\'></i>', '<i class=\'icon-arrow-right\'></i>'] : '',
          responsive: {
            0: {
              items: 1,
              nav: true,
              onInitialized: function() {
                $(".icon-arrow-left").addClass("deactivated");
              },
              onTranslated: function(event){
                $('.icon-arrow-right').removeClass('deactivated');
                $('.icon-arrow-left').removeClass('deactivated');
                if (event.item.index === 0){
                  $(".icon-arrow-left").addClass("deactivated");
                } else {
                  $(".icon-arrow-left").show();
                }
                if (event.item.index === (event.item.count - 1)){
                  $(".icon-arrow-right").addClass("deactivated");
                } else {
                  $(".icon-arrow-right").show();
                }
              }
            },
          },
        }).on('changed.owl.carousel', function(event) {
          // let currentTab = Math.abs(event.page.index - (event.relatedTarget._clones.length / 2));
          // self.changeDay(currentTab);
        }).on('click', '.item', function () {
          // self.clickOnImage(self.infoByCategory[self.prizeInfo.type].prizes[self.infoByCategory[self.prizeInfo.type].tabActive]);
        }).trigger('to.owl.carousel', 0);// self.infoByCategory[self.prizeInfo.type].tabActive);
      });
      /* eslint-enable */
    },
    fetchData() {
      Promise.all([
        this.storeJackpotPrizes({ lang: this.getLocale || localStorage.getItem('lang') }),
        this.storeJackpotRankData(),
      ]).then(() => {
        this.initCarousel();
      });
    },
    getDateFormat(date, format) {
      this.$moment.locale(this.getLocale.toLowerCase());
      return this.$moment(date).format(format);
    },
  },
  computed: {
    getPrizes() {
      return this.jackpotPrizes;
    },
    getFbPoints() {
      const userPoints = (this.userDetails.facebookId ? this.userDetails.totalPointsEarned : this.userDetails.totalPointsEarned + this.connectionPoints);
      return this.roundUpNumber(Math.floor(userPoints * 0.05));
    },
    numOfDays() {
      const currentDate = new Date();
      const endDate = new Date();
      endDate.setDate(this.jackpotCountdownDay);
      if (currentDate.getDate() < this.jackpotCountdownDay) {
        endDate.setMonth(currentDate.getMonth());
      } else {
        endDate.setMonth(currentDate.getMonth() + 1);
      }
      return this.dateDifferenceInDays(currentDate, endDate);
    },
    ...mapState('profile', [
      'jackpotPrizes',
      'jackpotRankData',
    ]),
    ...mapState('common', [
      'userDetails',
      'facebookFunctionality',
      'jackpotCountdownDay',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getLocale',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/jackpot/Jackpot.vue